import { api } from './api';
import type { SessionPolicyResponse, SessionPolicyUpdatePayload } from '../types/sessionPolicy';

export const sessionPolicyApi = {
  get: (projectId: string) =>
    api.get<SessionPolicyResponse>(`/api/projects/${projectId}/settings/token-policy`),

  // The Rails route accepts both PATCH and PUT; the api helper only exposes PUT.
  update: (projectId: string, data: SessionPolicyUpdatePayload) =>
    api.put<SessionPolicyResponse>(`/api/projects/${projectId}/settings/token-policy`, data),
};
